import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "preset",
    "customPanel",
    "frequency",
    "interval",
    "weekdayPanel",
    "weekday",
    "endNever",
    "endCount",
    "endUntil",
    "count",
    "until",
    "output",
  ]

  presetChanged() {
    const value = this.presetTarget.value

    if (value === "custom") {
      this.customPanelTarget.classList.remove("hidden")
      this.buildRule()
    } else {
      this.customPanelTarget.classList.add("hidden")
      this.outputTarget.value = value
    }
  }

  buildRule() {
    const freq = this.frequencyTarget.value
    const interval = parseInt(this.intervalTarget.value) || 1

    let parts = [`FREQ=${freq}`]

    if (interval > 1) {
      parts.push(`INTERVAL=${interval}`)
    }

    // Weekday selection for weekly
    if (freq === "WEEKLY") {
      this.weekdayPanelTarget.classList.remove("hidden")
      const checked = this.weekdayTargets
        .filter((cb) => cb.checked)
        .map((cb) => cb.value)
      if (checked.length > 0) {
        parts.push(`BYDAY=${checked.join(",")}`)
      }
    } else {
      this.weekdayPanelTarget.classList.add("hidden")
    }

    // End condition
    if (this.hasEndCountTarget && this.endCountTarget.checked) {
      const count = parseInt(this.countTarget.value) || 10
      parts.push(`COUNT=${count}`)
    } else if (
      this.hasEndUntilTarget &&
      this.endUntilTarget.checked &&
      this.untilTarget.value
    ) {
      const until = this.untilTarget.value.replace(/-/g, "") + "T235959Z"
      parts.push(`UNTIL=${until}`)
    }

    this.outputTarget.value = parts.join(";")
  }
}
